// App.js
import React from "react";
import "./App.css";
import Header from "./components/Header";
import Intro from "./components/Intro";
import Showcase from "./components/Showcase";
import ShowcaseAlt from "./components/ShowcaseAlt";
import Hardware from "./components/Hardware";
import Contact from "./components/Contact";
import About from "./components/About";
import ParticleField from './components/ParticleField';
import ConstellationField from './components/ConstellationField';
import AscendingLines from './components/AscendingLines';

const App = () => {
  return (
    <div className="App">
      <Header />
      <Intro />
      <About />
      <ParticleField />
      <section id="showcase">
        <Showcase />
      </section>
      <section id="showcase-alt">
        <ShowcaseAlt />
      </section>
      <ConstellationField />
      <section id="hardware">
        <Hardware />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <AscendingLines />
    </div>
  );
};

export default App;
